import AuthRequestHelper from './AuthRequestHelper'
import AllowRecUserList from '../allowRecUsers'

class UserMatchHelper{
    async getRecProfile(id,matchNo){
        try{
            const requestUrl="recuser/"+id
            //return await AuthRequestHelper.request("get",requestUrl,{matchNo:matchNo})
        
            let response=await AuthRequestHelper.request("get",requestUrl,{matchNo:matchNo})

            console.log("BEFORE",response.recUser)
            let filteredResponse= response.recUser.filter(eachUser=> AllowRecUserList.includes(eachUser.id))
            filteredResponse.recUser= filteredResponse
            console.log("AFTER",filteredResponse)


            

            //basically do not filter
            //
            return response
            

        }
        catch(error){
            console.log(error)
            return{}
        }

    }
}

export default new UserMatchHelper();